import { OnboardingDetails } from './tour.types';

import { TourRegistryKey } from './tour.registry';

export type TourPersistence = {
  hasSeen(id: TourRegistryKey, userId: string): boolean;
};

const readStorage = (userId: string): Record<string, OnboardingDetails> => {
  try {
    const raw = localStorage.getItem(userId);

    if (!raw) {
      return {};
    }

    return JSON.parse(raw) as Record<string, OnboardingDetails>;
  } catch {
    return {};
  }
};

export const createTourPersistence = (
  registry: Record<string, { version: number }>
): TourPersistence => {
  return {
    hasSeen(id: TourRegistryKey, userId: string) {
      const store = readStorage(userId);
      const entry = store[id];

      if (!entry) {
        return false;
      }

      return entry.viewed && entry.version === registry[id]?.version;
    },
  };
};
